module.exports = __webpack_public_path__ + "static/media/composer_mic.a6922a1a.svg";